module.exports = __webpack_public_path__ + "img/en_eow.94ed3a24.jpg";